import { useVenueContext } from '../components/context/VenueContext';
import { formatTaxLabel, calcOrderTotals } from '../config/venueConfig';

export function useVenue() {
  const { settings, taxLabel, calcTotals, sections, cuisineTypes } = useVenueContext();
  return {
    ...settings,
    taxLabel,
    calcTotals,
    sections,
    cuisineTypes,
  };
}

export { formatTaxLabel, calcOrderTotals };
